<template>
  <div class="content-item">
    <p v-text="errorMessage" />
  </div>
</template>

<script>
export default {
  props: {
    errorMessage: {
      type: String,
      default: 'Something went wrong!',
    },
  },
};
</script>
